<template>
  <div>
    <div
      v-show="active == 0"
      class="tab-container"
    >
      <v-income :form="ruleForm" />
      <van-button
        v-if="!ruleForm.status || ruleForm.status < 2"
        type="info"
        block
        @click="handleIncome(1)"
      >
        保存今日收入，去录入支出
      </van-button>
      <van-button
        v-else
        type="info"
        block
        @click="handleIncome(1)"
      >
        查看今日支出
      </van-button>
      <van-button
        type="default"
        block
        @click="back"
      >
        取消
      </van-button>
    </div>
    <div
      v-show="active == 1"
      class="tab-container"
    >
      <v-expend :form="ruleForm" />
      <van-button
        v-if="!ruleForm.status || ruleForm.status < 2"
        type="info"
        block
        @click="submit"
      >
        保存并提交今日收入与支出
      </van-button>
      <van-button
        type="default"
        block
        @click="handleTab(0)"
      >
        {{ (!ruleForm.status || ruleForm.status &lt; 2) ? '返回修改今日收入' : '返回查看今日收入' }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { Update, Save } from '@/api/daily';
import vIncome from "./income";
import vExpend from "./expend";
export default {
  name: "Index",
  components: {
    vIncome,
    vExpend
  },
  data() {
    return {
			active: 0,
			shopInfo:{},
      supCurrency: "",
      ruleForm: {
        dailyId: "",
        shopId: "",
        shopName: "",
        retailTime: "",
        cardIncomeEur: "",
        cashIncomeEur: "",
        cashIncomeChf: "",
        incomePayply: "",
        mealIncome: "",
        remark: "",
        otherIncomeEur: "",
        otherIncomeChf: "",
        otherIncomeMeal: "",
        incomeRemark: "",
        outlayRemark: "",
        tDayCustomerCount: "",
        morningCustomerCount: "",
        eveningCustomerCount: "",
        listDailyOut: [
          {
            outProductName: "",
            currency: "1",
            outlayMoney: ""
          }
        ]
      }
    };
  },
  created() {
		this.shopInfo = JSON.parse(localStorage.getItem("sushiWechatShopInfo"))
		this.supCurrency = this.shopInfo.supCurrency;
		this.ruleForm.shopId = this.shopInfo.sid;
		this.ruleForm.shopName = this.shopInfo.shopName;
	},
  methods: {
		async submit(){
			this.$toast.loading({
				duration: 0,
				message: '加载中...',
				forbidClick: true,
      });
      const {
        listDailyOut
      } = this.ruleForm
      let name = true, money = true
      listDailyOut.forEach(item => {
        if(!item.outProductName)
        name = false
        if(!item.outlayMoney)
        money = false
      });
      if(name && !money){
				this.$toast('请输入支出金额');
				return
      }
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      const _listDailyOut = params.listDailyOut.filter(item => {
        return item.outProductName
      })
      params.listDailyOut = _listDailyOut ? _listDailyOut : [];
			const res = params.dailyId ? await Update(params) : await Save(params);
			this.$toast.clear();
      if (res && res.code == 0) {
				this.$toast.success('操作成功');
				this.$router.push({path: '/index'})
      }
		},
		handleIncome(active){
			const {
				cashIncomeEur, cashIncomeChf, mealIncome, cardIncomeEur, incomePayply, otherIncomeEur, otherIncomeChf, otherIncomeMeal, incomeRemark
			} = this.ruleForm;
			const {
				supCurrency
			} = this
			// if(morningCustomerCount == ""){
			// 	this.$toast('请输入早上客流');
			// 	return
			// }
			// if(eveningCustomerCount == ""){
			// 	this.$toast('请输入晚上客流');
			// 	return
			// }
			if(cashIncomeEur == ""){
				this.$toast('请输入现金收入');
				return
			}
			if(supCurrency.indexOf('2')>-1 && cashIncomeChf == ""){
				this.$toast('请输入法郎收入');
				return
			}
			if(supCurrency.indexOf('3')>-1 && mealIncome == ""){
				this.$toast('请输入饭票收入');
				return
			}
			if(cardIncomeEur == ""){
				this.$toast('请输入刷卡收入');
				return
      }
			if(incomePayply == ""){
				this.$toast('请输入ANCV收入');
				return
      }
      
      if((otherIncomeEur || otherIncomeChf || otherIncomeMeal) && !incomeRemark){
				// this.$toast('请输入其他收入备注');
				// return
      }
			this.handleTab(active)
		},
    handleTab(active) {
			this.active = active;
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-container {
  padding: 20px;
  .van-button {
    margin-top: 30px;
  }
}
</style>